import React, { useEffect, useContext, useState } from "react";
import Grid from "@mui/material/Grid2";
import { Button } from "react-bootstrap";
import { Link } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Navigation from "../Components/Navigation";
import ContactRibbon from "../Components/ContactRibbon";
import Footer from "../Components/Footer";
import mapsection from "../Images/Micanopy-map.jpg";
import communityicon from '../Assets/community-icon.png';
import economyicon from '../Assets/economy-icon.png';
import healthcareicon from '../Assets/healthcare-icon.png';
import transportationicon from '../Assets/transportation-icon.png';
import youthicon from '../Assets/concerns-icon.png';
import commentsbg from '../Assets/comments-bg3.png';
import Newsletter7 from '../Images/FF-Newsletter-issue-7.jpg';


import { MondayContext } from "../Contexts/MondayContext";
import Hero from "../Components/Hero";
import ScrollToTopButton from "../Components/ScrollTop";

export default function Home() {
  const { meetingsData, projectsData } = useContext(MondayContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Home";
  }, []);

  const [meetingsExpanded, setMeetingsExpanded] = useState(false);
  const [projectsExpanded, setProjectsExpanded] = useState(false);

  const handleMeetingChange = (panel) => (event, isMeetingsExpanded) => {
    setMeetingsExpanded(isMeetingsExpanded ? panel : false);
  };
  const handleProjectsChange = (panel) => (event, isProjectsExpanded) => {
    setProjectsExpanded(isProjectsExpanded ? panel : false);
  };
  return (
    <main>
      <Navigation />
      {/* CODE FOR THE HERO SECTION*/}
    
      <Hero/>
      <section>
        <ScrollToTopButton/>
      <Grid container size={{ xs: 12, md: 12, lg: 12, xl: 12 }} className="last-container ff-description" >
        <Grid
        container
        item
          size={{ xs: 12, md: 12, lg: 12, xl: 10 }}
          justifyContent='center'
        >
           <Grid container item paddingBottom='2%'>
          <h1>What is Forward Focus?</h1>
        </Grid>
          <p className='ff-paragraph'>
            Forward Focus: Eastern Alachua County is a comprehensive
            initiative to improve the quality of life and economic
            opportunities in the eastern part of Alachua County. This
            project will identify and address critical needs, such as
            affordable housing, job creation, access to healthcare, and
            environmental sustainability. By engaging with community
            members, conducting thorough research, and collaborating with
            local partners, we aim to create a thriving and resilient future
            for the Eastern Alachua County region.
          </p>
      
        </Grid>
   
      </Grid>
      
   
      </section>
         {/**********Code for the static Accordion STARTS Here ******************/}
      <section className="meetings-container">
        <Grid
          container
          size={{xs:12, sm:12, md:10,lg:8 }}
          className='newsletter-content'
    
        >
         <Grid
            container
            size={{ xs: 12, sm: 12, md: 12, lg: 5, xl: 5 }}
            justifyContent="center"
             className='newsletter-spacing'
           
          >
            <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} justifyContent='center' flexDirection='column' alignItems='center'>
            <Link target='blank' href='https://alachuacounty.us/Depts/epd/Resiliency/Documents/Forward%20Focus%20Newsletters/FF-Newsletter-issue-7.pdf'>
                  <img className="newsletter-image" src={Newsletter7} alt="Newsletter 7" />
                  </Link>
          <Link  href="/newsletters" underline="none" paddingTop='2%'>
                <Button className="custom-button" >
                  VIEW OUR NEWSLETTERS
                </Button>
              </Link>
            </Grid>
            <Grid container size={12} justifyContent="center">
          
            </Grid>
          </Grid>
          <Grid
            container
            size={{ xs: 12, sm: 12, md: 12, lg: 7, xl: 7 }}
            justifyContent="center"
          >
        
            {/* Code for the static Accordion Starts Here */}
            <Grid container flexDirection='column' size={{ xs: 11, sm: 11, md: 12, lg: 12, xl: 10 }}  justifyContent='center'  >
            <Grid
              size={12}
              container
              justifyContent="center"  
              spacing={2}
              marginBottom='4%'
            >
              <h1>Upcoming Meetings</h1>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} marginBottom='2%' textAlign='center'>
            <p > These meetings will be held in various locations across eastern
              Alachua County. Upcoming dates and times are currently being
              scheduled.</p>
            </Grid>
            
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} >
   
            <Grid container item size={{xs:12}} justifyContent='center'>

<Typography variant='h5' fontWeight='bold'>There are Currently No Upcoming Meetings</Typography>

</Grid>
            {/* <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                  <strong>Meeting Name : </strong>
                  Community Input Session in Melrose
                  <br />
                  <strong>Date & Time : </strong>
                  May 3, 2025, 9:00 AM 
                  <br />
                  <strong>Location : </strong>
                  Melrose United Methodist Church (5807 Hampton St., Melrose, FL, 32666)
                  
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">
                  <strong>Description:</strong><br/>In May, the Forward Focus initiative will host a community input session in Melrose. The session will be held on Saturday, May 3, 2025, at 9 a.m. at the Melrose United Methodist Church (5807 Hampton St., Melrose, FL, 32666). All residents, businesses, and local leaders are encouraged to attend. This session will provide an opportunity to share insights and ideas about the future of Alachua County and Melrose. During this meeting, Alachua County staff will outline the project’s goals and timelines. Additionally, staff will hear attendees’ valuable feedback, which will assist in identifying development opportunities and common themes in Eastern Alachua County. 
                </Typography>
              </AccordionDetails>
            </Accordion> */}
            </Grid>
         
                {/**********Code for the static Accordion ENDS Here ******************/}



              {/* commented out the dynamic meetins data due to backend deployment issue. */}
              {/* {meetingsData ? (
                meetingsData[0].slice(0, 3).map((item) => (
                  <Accordion
                    key={item.id}
                    expanded={meetingsExpanded === item.id}
                    onChange={handleMeetingChange(item.id)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel${item.id}-content`}
                      id={`panel${item.id}-header`}
                    >
                      <Typography>
                        <strong>Meeting Name : </strong>
                        {item.MeetingName}
                        <br />
                        <strong>Date & Time : </strong>
                        {item.DateTime}
                        <br />
                        <strong>Location : </strong>
                        {item.Location}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography variant="body2">
                        <strong>Description:</strong> {item.Description}
                      </Typography>

                      {item.Attachments.length > 0 ? (
                        <Typography variant="body2" sx={{ marginTop: 1 }}>
                          <strong>Attachments:</strong>
                          {item.Attachments.map((attachment, index) => (
                            <div key={index}>
                              <a
                                href={attachment[1]}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {attachment[0]}
                              </a>
                            </div>
                          ))}
                        </Typography>
                      ) : (
                        ""
                      )}
                    </AccordionDetails>
                  </Accordion>
                ))
              ) : (
                <p>Waiting for meetings data ...</p>
              )} */}

<Grid container size={12} justifyContent="center" alignContent='center' pt={3} >
              <Link href="/meetings" fontWeight='bold' className="meetings-link">
             
              VIEW ALL PAST AND UPCOMING MEETINGS
            
              </Link>
            </Grid>
            </Grid>  
          </Grid>
        </Grid>
      </section>

      {/* CODE FOR THE MAPS SECTION */}
      <section className="maps-container">
        <Grid
          container
          spacing={3}
          size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
          justifyContent="center"
        >
          <Grid
            item
            size={12}
            container
            justifyContent="center"
          >
            <h1>Eastern Alachua County Maps</h1>
          </Grid>

          <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 5, xl: 5 }}
            container
            flexDirection="column"
            justifyContent='center'
            textAlign='center'
            line-height='2.5em'
          >
            <p style={{padding: '0 8%'}} >
              Visualize Eastern Alachua County's municipalities and
              unincorporated areas
            </p>

            <Grid container justifyContent="center">
              <Link href="/maps" underline="none">
                <Button className="alt-button">VIEW MAPS</Button>
              </Link>
            </Grid>
          </Grid>

          <Grid
            container
            size={{ xs: 12, sm: 12, md: 12, lg: 7, xl: 7 }}
            className="map-img-container"
            justifyContent="center"
          >
            <img   src={mapsection} className="map-img" alt="Image of a Forward Focus Map that shows Micanopy, Florida" />
          </Grid>
        </Grid>
      </section>

 
      {/* CODE FOR THE KEY ISSUES SECTION */}
      <section className="key-issues-container">
  
<Grid container size={12} justifyContent='center' paddingBottom='1%'>
  <Grid container item size={12} justifyContent='center' style={{paddingBottom:'2%'}}>
  <h1 >Key Issues</h1>
  </Grid>


  <Grid container item size={12} justifyContent='center' spacing={2} className='icon-wrapper' >

    <Grid container size={{xs:12, lg:'auto'}} style={{justifyContent:'center!important'}} className='icon-container'>
      <Grid container item size={12} justifyContent='center'>
  <img className="issue-icon-img" src={communityicon} alt='An Icon of three people with a conversation bubble above them '/>
      </Grid>
      <Grid container item size={{xs:12,sm:12,md:12}} style={{justifyContent:'center'}}>
        <Link href='/issues#engagement'className='key-issue-jumplink'>
      <Button className='custom-button'> Community Engagement </Button>
        </Link>
      </Grid>

    </Grid>

    <Grid container size={{xs:12, lg:'auto'}} style={{justifyContent:'center!important'}} className='icon-container'>
      <Grid container item size={12} justifyContent='center'>
      <img className="issue-icon-img" src={economyicon} />
      </Grid>
      <Grid container item size={12} justifyContent='center'>
      <Link href='/issues#development'className='key-issue-jumplink' alt='An Icon of a hand holding a dollar bill '>
      <Button className='custom-button'> Economic Development</Button>
        </Link>
      </Grid>

    </Grid>

    <Grid container size={{xs:12, lg:'auto'}}  style={{justifyContent:'center!important'}} className='icon-container'>
      <Grid container item size={12} justifyContent='center'>
      <img className="issue-icon-img" src={healthcareicon} />
      </Grid>
      <Grid container item size={12} justifyContent='center'>
      <Link href='/issues#healthcare'className='key-issue-jumplink' alt='An Icon of an uppercase H which is referring to Healthcare '>
      <Button className='custom-button'> Healthcare </Button>
        </Link>
      </Grid>

    </Grid>
    <Grid container size={{xs:12, lg:'auto'}}  style={{justifyContent:'center!important'}}className='icon-container' >
      <Grid container item size={12} justifyContent='center'>
      <img className="issue-icon-img" src={transportationicon} />
      </Grid>
      <Grid container item size={12} justifyContent='center'>
      <Link href='/issues#transportation' className='key-issue-jumplink' alt='An Icon of  a bus and a car '>
      <Button className='custom-button'> Transportation </Button>
        </Link>
      </Grid>

    </Grid>

    <Grid container size={{xs:12, lg:'auto'}}  style={{justifyContent:'center!important'}}className='icon-container'>
      <Grid container item size={12} justifyContent='center'>
      <img className="issue-icon-img" src={youthicon} />
      </Grid>
      <Grid container item size={12} justifyContent='center'>
      <Link  href='/issues#youthconcerns'className='key-issue-jumplink' alt='An Icon of a person with a question mark near the head '>
      <Button className='custom-button'> Youth Concerns </Button>
        </Link>
      </Grid>

    </Grid>

</Grid>



</Grid>



      </section>


      {/* CODE FOR THE LINK TO TABLE SECTION */}
      <section padding='2% 0' backgroundColor='#E7E7E7'>
<Grid container size={12}   backgroundColor='#E7E7E7' >

  <Grid container item size={{xs:12, md:12, lg:6, xl:6}} justifyContent='center' padding='2% 0'  >
  <Grid container size={{xs:12}} justifyContent='center'>
<h1 textAlign='center!important'>Public Commentary Table</h1>
</Grid>
<Grid container size={{xs:11}} justifyContent='center' textAlign='center!important'>
<p className='table-description' >
  Explore Local Insights, share your thoughts, and contribute to improving your neighborhood.
</p>
</Grid>
<Grid container size={{xs:12}} justifyContent='center'>
  <Grid container item size={{xs:12,sm:6, md:6}} justifyContent='end' className='view-comment-button-container' >
  <Link  href='/comments' className='view-comment-link'>
  <Button className='custom-button'>
View Comments
  </Button>
  </Link>
  </Grid>
  <Grid container item size={{xs:12,sm:6, md:6}} justifyContent='start' className='submit-comment-button-container'>
  <Link        href="https://wkf.ms/4jlqDeG" // The external URL to new Monday Form for board ID : 8854597261 updated on 4/9/25
                          target="_blank"
                          rel="noopener noreferrer"
                          className='submit-comment-link'>
  <Button className='custom-button' >
Submit Your Comments
  </Button>
  </Link>
  </Grid>
  </Grid>

  </Grid>


  <Grid container item size={{xs:12, lg:6, xl:5}} justifyContent='center' style={{paddingTop:'1%'}}>
<img width='100%' className='comment-img' alt='A graphic of five people conversing with message bubbles above their heads' src={commentsbg}/>
</Grid>

  


</Grid>

      </section>

      {/* CODE FOR THE CONTACT US RIBBON */}
      <section className="contact-container " backgroundColor="#99d6d0">
        <ContactRibbon   />
      </section>

      <Footer />
    </main>
  );
}
